import { Button, CircularProgress } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

/**
 * The one「重新整理」control every list page uses. QA #35 asked for the
 * audit-log page's rendering everywhere: an outlined button with the icon
 * and the word, not a bare icon (nine pages had four variants). Disabled
 * while the list is loading, spinner in place of the icon meanwhile.
 */
export default function RefreshButton({
  onClick,
  loading = false,
  label = '重新整理',
}: {
  onClick: () => void;
  loading?: boolean;
  label?: string;
}) {
  return (
    <Button
      variant="outlined"
      startIcon={loading ? <CircularProgress size={16} /> : <RefreshIcon />}
      onClick={onClick}
      disabled={loading}
      aria-label={label}
    >
      {label}
    </Button>
  );
}
